export enum PollingDuration {
  short = 5000,
  infrequent = 30000,
  long = 120000,
}
